import { toPng } from 'html-to-image';
import html2canvas from 'html2canvas';

export const toCanvas = (e, options = {}) => {
  return html2canvas(e, {
    backgroundColor: null,
    allowTaint: false,
    useCORS: true,
    imageTimeout: 0,
    ...options
  });
};

export const elementToPng = (e, options = {}) => {
  return toPng(e, {
    cacheBust: true,
    includeQueryParams: true,
    quality: 0.92,
    ...options
  });
};
